// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".airport-select[data-v-1c87f919]{position:relative}.airport-select .dropdown-list[data-v-1c87f919]{width:100%}.airport-select[data-v-1c87f919] .dropdown-list-content{max-height:50vh;min-height:15rem}@media (min-width:1024px){.airport-select[data-v-1c87f919] .dropdown-list-content{max-height:10rem;min-height:10rem}}.airport-select .error-message[data-v-1c87f919]{left:0;position:absolute;top:calc(100% + .5rem)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
